<template>
  <div class="daiei-flyer-cards">
    <ul class="daiei-flyer-cards__items c-page-shop__flyer-list">
      <daiei-flyer-card
        v-for="(item, index) in items"
        v-bind="item"
        :key="index"
        :shop-id="shopId"
        :utm-source="utmSource"
        :location="getLocation(index)"
        @click="emitClick($event)"
        @intersect="emitIntersect"
      />
    </ul>
  </div>
</template>

<script setup>
import DaieiFlyerCard from '@/components/DaieiFlyerCard'

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  shopId: {
    type: [Number, String, null],
    default: null,
  },
  location: {
    type: Object,
    default: null,
  },
  utmSource: {
    type: [Number, String, null],
    default: null,
  },
})

const emit = defineEmits(['click', 'intersect'])
 
const isActive = ref(false)

const emitClick = (obj) => {
  emit('click', obj)
}

const emitIntersect = (data) => {
  emit('intersect', data)
}

const getLocation = (index) => {
  if (props.location) {
    const newLocation = { ...props.location }
    newLocation.element_line_number = index + 1
    return newLocation
  }
  return null
}
</script>

<style lang="scss" scoped>
.daiei-flyer-cards {
  max-width: 960px;
  margin: 0 auto;

  @media screen and (max-width: 767px) {
    width: auto;
    // margin: -2.77778vw auto 0;
    position: relative;
    overflow: hidden;
    -webkit-transition: height 300ms;
    transition: height 300ms;
  }

  .daiei-flyer-cards__items {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
}
</style>
